export enum FeatureFlag {
  All = 'All',
  CourseEditor = 'CourseEditor',
  InstitutionCreatorDropdown = 'InstitutionCreatorDropdown',
  CookieConsent = 'CookieConsent',
}
